import React from 'react';

function Footer() {
  return (
    <footer className="main-footer">
      
      <p>VRAS&#169; 2024 All rights reserved.</p>
        
    </footer>
  );
}

export default Footer;